import type {Message} from '@bufbuild/protobuf';
import type {GenEnum, GenFile, GenMessage} from '@bufbuild/protobuf/codegenv2';
import {enumDesc, fileDesc, messageDesc} from '@bufbuild/protobuf/codegenv2';
import type {AccessibilityOverrides, AccessibilitySettings} from './accessibility_pb';
import {file_fluxer_user_preferences_v1_accessibility} from './accessibility_pb';
import type {
	EmojiPickerState,
	EmojiState,
	EmojiStickerLayoutSettings,
	FavoriteGifSettings,
	MemesPickerState,
	SoundSettings,
	StickerPickerState,
} from './pickers_pb';
import {file_fluxer_user_preferences_v1_pickers} from './pickers_pb';

export const file_fluxer_user_preferences_v1_preferences: GenFile =
	fileDesc(
		'CixmbHV4ZXIvdXNlci9wcmVmZXJlbmNlcy92MS9wcmVmZXJlbmNlcy5wcm90bxIaZmx1eGVyLnVzZXIucHJlZmVyZW5jZXMudjEigBMKEVN5bmNlZFByZWZlcmVuY2VzEkgKDWFjY2Vzc2liaWxpdHkYASABKAsyMS5mbHV4ZXIudXNlci5wcmVmZXJlbmNlcy52MS5BY2Nlc3NpYmlsaXR5U2V0dGluZ3MSUwoXYWNjZXNzaWJpbGl0eV9vdmVycmlkZXMYAiABKAsyMi5mbHV4ZXIudXNlci5wcmVmZXJlbmNlcy52MS5BY2Nlc3NpYmlsaXR5T3ZlcnJpZGVzEksKD3RleHR1YWxfcHJldmlldxgDIAEoCzIyLmZsdXhlci51c2VyLnByZWZlcmVuY2VzLnYxLlRleHR1YWxQcmV2aWV3U2V0dGluZ3MSQgoMZW1vamlfcGlja2VyGBQgASgLMiwuZmx1eGVyLnVzZXIucHJlZmVyZW5jZXMudjEuRW1vamlQaWNrZXJTdGF0ZRJGCg5zdGlja2VyX3BpY2tlchgVIAEoCzIuLmZsdXhlci51c2VyLnByZWZlcmVuY2VzLnYxLlN0aWNrZXJQaWNrZXJTdGF0ZRJCCgxtZW1lc19waWNrZXIYFiABKAsyLC5mbHV4ZXIudXNlci5wcmVmZXJlbmNlcy52MS5NZW1lc1BpY2tlclN0YXRlEjUKBWVtb2ppGBcgASgLMiYuZmx1eGVyLnVzZXIucHJlZmVyZW5jZXMudjEuRW1vamlTdGF0ZRJUChRlbW9qaV9zdGlja2VyX2xheW91dBgYIAEoCzI2LmZsdXhlci51c2VyLnByZWZlcmVuY2VzLnYxLkVtb2ppU3RpY2tlckxheW91dFNldHRpbmdzEkYKDWZhdm9yaXRlX2dpZnMYGSABKAsyLy5mbHV4ZXIudXNlci5wcmVmZXJlbmNlcy52MS5GYXZvcml0ZUdpZlNldHRpbmdzEj0KCWZhdm9yaXRlcxgoIAEoCzIqLmZsdXhlci51c2VyLnByZWZlcmVuY2VzLnYxLkZhdm9yaXRlc1N0YXRlEksKD3JlY2VudF9tZW50aW9ucxgpIAEoCzIyLmZsdXhlci51c2VyLnByZWZlcmVuY2VzLnYxLlJlY2VudE1lbnRpb25zU2V0dGluZ3MSPwoHc2lkZWJhchgqIAEoCzIuLmZsdXhlci51c2VyLnByZWZlcmVuY2VzLnYxLlNpZGViYXJQcmVmZXJlbmNlcxJACgttZW1iZXJfbGlzdBgrIAEoCzIrLmZsdXhlci51c2VyLnByZWZlcmVuY2VzLnYxLk1lbWJlckxpc3RTdGF0ZRJICg91bnJlYWRfY2hhbm5lbHMYLCABKAsyLy5mbHV4ZXIudXNlci5wcmVmZXJlbmNlcy52MS5VbnJlYWRDaGFubmVsc1N0YXRlEkoKEG1lbnRpb25fZnJlY2VuY3kYLSABKAsyMC5mbHV4ZXIudXNlci5wcmVmZXJlbmNlcy52MS5NZW50aW9uRnJlY2VuY3lTdGF0ZRI9CgduYWdiYXJzGDwgASgLMiwuZmx1eGVyLnVzZXIucHJlZmVyZW5jZXMudjEuTmFnYmFyRGlzbWlzc2FscxJHChFkaXNtaXNzZWRfdXBzZWxscxg9IAEoCzIsLmZsdXhlci51c2VyLnByZWZlcmVuY2VzLnYxLkRpc21pc3NlZFVwc2VsbHMSTgoVZ3VpbGRfbnNmd19hZ3JlZW1lbnRzGD4gASgLMi8uZmx1eGVyLnVzZXIucHJlZmVyZW5jZXMudjEuR3VpbGROc2Z3QWdyZWVtZW50cxI8Cgl3aGF0c19uZXcYPyABKAsyKS5mbHV4ZXIudXNlci5wcmVmZXJlbmNlcy52MS5XaGF0c05ld1N0YXRlEj8KB3ByaXZhY3kYUCABKAsyLi5mbHV4ZXIudXNlci5wcmVmZXJlbmNlcy52MS5Qcml2YWN5UHJlZmVyZW5jZXMSUAoUbG9jYWxfc3BhbV9vdmVycmlkZXMYUSABKAsyMi5mbHV4ZXIudXNlci5wcmVmZXJlbmNlcy52MS5Mb2NhbFVzZXJTcGFtT3ZlcnJpZGVzEhUKDXNhbml0aXplX3VybHMYUiABKAgSOAoFc291bmQYZCABKAsyKS5mbHV4ZXIudXNlci5wcmVmZXJlbmNlcy52MS5Tb3VuZFNldHRpbmdzEkIKCnNwZWxsY2hlY2sYZSABKAsyLi5mbHV4ZXIudXNlci5wcmVmZXJlbmNlcy52MS5TcGVsbGNoZWNrU2V0dGluZ3MSSAoOc2VhcmNoX2VuZ2luZXMYZiABKAsyMC5mbHV4ZXIudXNlci5wcmVmZXJlbmNlcy52MS5TZWFyY2hFbmdpbmVTZXR0aW5ncxJPChFwZXJtaXNzaW9uX2xheW91dBhnIAEoCzI0LmZsdXhlci51c2VyLnByZWZlcmVuY2VzLnYxLlBlcm1pc3Npb25MYXlvdXRTZXR0aW5ncxJSChNndWlsZF9tZW1iZXJfbGF5b3V0GGggASgLMjUuZmx1eGVyLnVzZXIucHJlZmVyZW5jZXMudjEuR3VpbGRNZW1iZXJMYXlvdXRTZXR0aW5ncxJLCg1ndWlsZF9mb2xkZXJzGGkgASgLMjQuZmx1eGVyLnVzZXIucHJlZmVyZW5jZXMudjEuR3VpbGRGb2xkZXJFeHBhbmRlZFN0YXRlElAKFGhpZGRlbl9ndWlsZF9idXR0b25zGGogASgLMjIuZmx1eGVyLnVzZXIucHJlZmVyZW5jZXMudjEuSGlkZGVuR3VpbGRMaXN0QnV0dG9ucxJPChNrZXlib2FyZF9tb2RlX2ludHJvGGsgASgLMjIuZmx1eGVyLnVzZXIucHJlZmVyZW5jZXMudjEuS2V5Ym9hcmRNb2RlSW50cm9TdGF0ZRJRChBpbnB1dF9tb25pdG9yaW5nGGwgASgLMjcuZmx1eGVyLnVzZXIucHJlZmVyZW5jZXMudjEuSW5wdXRNb25pdG9yaW5nUHJvbXB0c1N0YXRlEkQKDXZvaWNlX3Byb21wdHMYbSABKAsyLS5mbHV4ZXIudXNlci5wcmVmZXJlbmNlcy52MS5Wb2ljZVByb21wdHNTdGF0ZRJACgtzdWRvX3Byb21wdBhuIAEoCzIrLmZsdXhlci51c2VyLnByZWZlcmVuY2VzLnYxLlN1ZG9Qcm9tcHRTdGF0ZRI9CghrZXliaW5kcxhvIAEoCzIrLmZsdXhlci51c2VyLnByZWZlcmVuY2VzLnYxLktleWJpbmRTZXR0aW5ncyKwAQoSU3BlbGxjaGVja1NldHRpbmdzEhQKB2VuYWJsZWQYASABKAhIAIgBARIRCglsYW5ndWFnZXMYAiADKAkSGwoTcGVyc29uYWxfZGljdGlvbmFyeRgDIAMoCRIYCgthdXRvX2RldGVjdBgEIAEoCEgBiAEBEhMKBmVuZ2luZRgFIAEoCUgCiAEBQgoKCF9lbmFibGVkQg4KDF9hdXRvX2RldGVjdEIJCgdfZW5naW5lIuYBChRTZWFyY2hFbmdpbmVTZXR0aW5ncxIiChV0ZXh0X3NlYXJjaF9lbmdpbmVfaWQYASABKAlIAIgBARIrCh5yZXZlcnNlX2ltYWdlX3NlYXJjaF9lbmdpbmVfaWQYAiABKAlIAYgBARIkChd0cmFuc2xhdGlvbl9wcm92aWRlcl9pZBgDIAEoCUgCiAEBQhgKFl90ZXh0X3NlYXJjaF9lbmdpbmVfaWRCIQofX3JldmVyc2VfaW1hZ2Vfc2VhcmNoX2VuZ2luZV9pZEIaChhfdHJhbnNsYXRpb25fcHJvdmlkZXJfaWQiZwoSUHJpdmFjeVByZWZlcmVuY2VzEh8KF2Rpc2FibGVfc3RyZWFtX3ByZXZpZXdzGAEgASgIEhwKD3Nob3dfYWN0aXZlX25vdxgCIAEoCEgAiAEBQhIKEF9zaG93X2FjdGl2ZV9ub3ciUAoWTG9jYWxVc2VyU3BhbU92ZXJyaWRlcxIYChBzcGFtbWVyX3VzZXJfaWRzGAEgAygJEhwKFG5vdF9zcGFtbWVyX3VzZXJfaWRzGAIgAygJIisKFlRleHR1YWxQcmV2aWV3U2V0dGluZ3MSEQoJd3JhcF90ZXh0GAEgASgIItwBChJTaWRlYmFyUHJlZmVyZW5jZXMSHAoUaW5saW5lX2Rtc19jb2xsYXBzZWQYASABKAgSLAofc2hvd19jb2xsYXBzZWRfdW5yZWFkX2Rtc19iYWRnZRgCIAEoCEgAiAEBEi8KInNob3dfaW5jb21pbmdfZnJpZW5kX3JlcXVlc3RfYmFkZ2UYAyABKAhIAYgBAUIiCiBfc2hvd19jb2xsYXBzZWRfdW5yZWFkX2Rtc19iYWRnZUIlCiNfc2hvd19pbmNvbWluZ19mcmllbmRfcmVxdWVzdF9iYWRnZSI9Cg9NZW1iZXJMaXN0U3RhdGUSGQoMbWVtYmVyc19vcGVuGAEgASgISACIAQFCDwoNX21lbWJlcnNfb3BlbiI0ChNVbnJlYWRDaGFubmVsc1N0YXRlEh0KFWNvbGxhcHNlZF9jaGFubmVsX2lkcxgBIAMoCSKqAQoWUmVjZW50TWVudGlvbnNTZXR0aW5ncxIdChBpbmNsdWRlX2V2ZXJ5b25lGAEgASgISACIAQESGgoNaW5jbHVkZV9yb2xlcxgCIAEoCEgBiAEBEhsKDmluY2x1ZGVfZ3VpbGRzGAMgASgISAKIAQFCEwoRX2luY2x1ZGVfZXZlcnlvbmVCEAoOX2luY2x1ZGVfcm9sZXNCEQoPX2luY2x1ZGVfZ3VpbGRzIv8BChRNZW50aW9uRnJlY2VuY3lTdGF0ZRJGCgZzY29wZXMYASADKAsyNi5mbHV4ZXIudXNlci5wcmVmZXJlbmNlcy52MS5NZW50aW9uRnJlY2VuY3lTdGF0ZS5TY29wZRo7CgVFbnRyeRIPCgd1c2VyX2lkGAEgASgJEg0KBWNvdW50GAIgASgNEhIKCmxhc3RfYXRfbXMYAyABKAMaYgoFU2NvcGUSEAoIZ3VpbGRfaWQYASABKAkSRwoHZW50cmllcxgCIAMoCzI2LmZsdXhlci51c2VyLnByZWZlcmVuY2VzLnYxLk1lbnRpb25GcmVjZW5jeVN0YXRlLkVudHJ5It0BCg5GYXZvcml0ZXNTdGF0ZRI9CghjaGFubmVscxgBIAMoCzIrLmZsdXhlci51c2VyLnByZWZlcmVuY2VzLnYxLkZhdm9yaXRlQ2hhbm5lbBJACgpjYXRlZ29yaWVzGAIgAygLMiwuZmx1eGVyLnVzZXIucHJlZmVyZW5jZXMudjEuRmF2b3JpdGVDYXRlZ29yeRIeChZjb2xsYXBzZWRfY2F0ZWdvcnlfaWRzGAMgAygJEhsKE2hpZGVfbXV0ZWRfY2hhbm5lbHMYBCABKAgSDQoFbXV0ZWQYBSABKAgikwEKD0Zhdm9yaXRlQ2hhbm5lbBISCgpjaGFubmVsX2lkGAEgASgJEhAKCGd1aWxkX2lkGAIgASgJEhYKCXBhcmVudF9pZBgDIAEoCUgAiAEBEhAKCHBvc2l0aW9uGAQgASgFEhUKCG5pY2tuYW1lGAUgASgJSAGIAQFCDAoKX3BhcmVudF9pZEILCglfbmlja25hbWUiPgoQRmF2b3JpdGVDYXRlZ29yeRIKCgJpZBgBIAEoCRIMCgRuYW1lGAIgASgJEhAKCHBvc2l0aW9uGAMgASgFIqMFChBOYWdiYXJEaXNtaXNzYWxzEhMKC2lvc19pbnN0YWxsGAEgASgIEhMKC3B3YV9pbnN0YWxsGAIgASgIEhkKEXB1c2hfbm90aWZpY2F0aW9uGAMgASgIEhwKFGRlc2t0b3Bfbm90aWZpY2F0aW9uGAQgASgIEhwKFHByZW1pdW1fZ3JhY2VfcGVyaW9kGAUgASgIEhcKD3ByZW1pdW1fZXhwaXJlZBgGIAEoCBIaChJwcmVtaXVtX29uYm9hcmRpbmcYByABKAgSHgoWcHJlbWl1bV90cmlhbF9leHBpcmluZxgIIAEoCBIWCg5naWZ0X2ludmVudG9yeRgJIAEoCBIYChBkZXNrdG9wX2Rvd25sb2FkGAogASgIEhwKFGd1aWxkX21lbWJlcnNoaXBfY3RhGAsgASgIEhUKDXZpc2lvbmFyeV9tZmEYDCABKAgSGwoTbGVnYWN5X3Bob25lX3VubGluaxgOIAEoCBJkChVwZW5kaW5nX2J1bGtfZGVsZXRpb24YDyADKAsyRS5mbHV4ZXIudXNlci5wcmVmZXJlbmNlcy52MS5OYWdiYXJEaXNtaXNzYWxzLlBlbmRpbmdCdWxrRGVsZXRpb25FbnRyeRJbChBpbnZpdGVzX2Rpc2FibGVkGBAgAygLMkEuZmx1eGVyLnVzZXIucHJlZmVyZW5jZXMudjEuTmFnYmFyRGlzbWlzc2Fscy5JbnZpdGVzRGlzYWJsZWRFbnRyeRo6ChhQZW5kaW5nQnVsa0RlbGV0aW9uRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgIOgI4ARo2ChRJbnZpdGVzRGlzYWJsZWRFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAg6AjgBIioKEERpc21pc3NlZFVwc2VsbHMSFgoOcGlja2VyX3ByZW1pdW0YASABKAgiaAoTR3VpbGROc2Z3QWdyZWVtZW50cxIaChJhZ3JlZWRfY2hhbm5lbF9pZHMYASADKAkSGAoQYWdyZWVkX2d1aWxkX2lkcxgCIAMoCRIbChNhZ3JlZWRfY2F0ZWdvcnlfaWRzGAMgAygJIlEKDVdoYXRzTmV3U3RhdGUSJAoXbGFzdF9kaXNtaXNzZWRfZW50cnlfaWQYASABKAlIAIgBAUIaChhfbGFzdF9kaXNtaXNzZWRfZW50cnlfaWQimgEKGFBlcm1pc3Npb25MYXlvdXRTZXR0aW5ncxJACgZsYXlvdXQYASABKA4yMC5mbHV4ZXIudXNlci5wcmVmZXJlbmNlcy52MS5QZXJtaXNzaW9uTGF5b3V0TW9kZRI8CgRncmlkGAIgASgOMi4uZmx1eGVyLnVzZXIucHJlZmVyZW5jZXMudjEuUGVybWlzc2lvbkdyaWRNb2RlIloKGUd1aWxkTWVtYmVyTGF5b3V0U2V0dGluZ3MSPQoEbW9kZRgBIAEoDjIvLmZsdXhlci51c2VyLnByZWZlcmVuY2VzLnYxLkd1aWxkTWVtYmVyVmlld01vZGUiNwoYR3VpbGRGb2xkZXJFeHBhbmRlZFN0YXRlEhsKE2V4cGFuZGVkX2ZvbGRlcl9pZHMYASADKAYiRgoWSGlkZGVuR3VpbGRMaXN0QnV0dG9ucxIXCg9kb3dubG9hZF9idXR0b24YASABKAgSEwoLaGVscF9idXR0b24YAiABKAgiJgoWS2V5Ym9hcmRNb2RlSW50cm9TdGF0ZRIMCgRzZWVuGAEgASgIIi8KG0lucHV0TW9uaXRvcmluZ1Byb21wdHNTdGF0ZRIQCghzZWVuX2N0YRgBIAEoCCJkChFWb2ljZVByb21wdHNTdGF0ZRIkChxza2lwX2hpZGVfb3duX2NhbWVyYV9jb25maXJtGAEgASgIEikKIXNraXBfaGlkZV9vd25fc2NyZWVuc2hhcmVfY29uZmlybRgCIAEoCCJ0Cg9TdWRvUHJvbXB0U3RhdGUSSAoUbGFzdF91c2VkX21mYV9tZXRob2QYASABKA4yJS5mbHV4ZXIudXNlci5wcmVmZXJlbmNlcy52MS5NZmFNZXRob2RIAIgBAUIXChVfbGFzdF91c2VkX21mYV9tZXRob2QiugEKD0tleWJpbmRTZXR0aW5ncxJCCg9jdXN0b21fa2V5YmluZHMYASADKAsyKS5mbHV4ZXIudXNlci5wcmVmZXJlbmNlcy52MS5DdXN0b21LZXliaW5kEhUKDXRyYW5zbWl0X21vZGUYAiABKAkSKgodcHVzaF90b190YWxrX3JlbGVhc2VfZGVsYXlfbXMYAyABKA1IAIgBAUIgCh5fcHVzaF90b190YWxrX3JlbGVhc2VfZGVsYXlfbXMihQEKDUN1c3RvbUtleWJpbmQSCgoCaWQYASABKAkSEwoGYWN0aW9uGAIgASgJSACIAQESNwoFY29tYm8YAyABKAsyKC5mbHV4ZXIudXNlci5wcmVmZXJlbmNlcy52MS5LZXliaW5kQ29tYm8SDwoHZW5hYmxlZBgEIAEoCEIJCgdfYWN0aW9uIs4CCgxLZXliaW5kQ29tYm8SCwoDa2V5GAEgASgJEhEKBGNvZGUYAiABKAlIAIgBARIUCgxjdHJsX29yX21ldGEYAyABKAgSDAoEY3RybBgEIAEoCBILCgNhbHQYBSABKAgSDQoFc2hpZnQYBiABKAgSDAoEbWV0YRgHIAEoCBITCgZnbG9iYWwYCCABKAhIAYgBARIUCgdlbmFibGVkGAkgASgISAKIAQESFQoNbW9kaWZpZXJfb25seRgKIAEoCBISCgpib3RoX3NpZGVzGAsgASgIEhkKDG1vdXNlX2J1dHRvbhgMIAEoDUgDiAEBEhsKDmdhbWVwYWRfYnV0dG9uGA0gASgNSASIAQFCBwoFX2NvZGVCCQoHX2dsb2JhbEIKCghfZW5hYmxlZEIPCg1fbW91c2VfYnV0dG9uQhEKD19nYW1lcGFkX2J1dHRvbiqCAQoUUGVybWlzc2lvbkxheW91dE1vZGUSJgoiUEVSTUlTU0lPTl9MQVlPVVRfTU9ERV9VTlNQRUNJRklFRBAAEiAKHFBFUk1JU1NJT05fTEFZT1VUX01PREVfQ09NRlkQARIgChxQRVJNSVNTSU9OX0xBWU9VVF9NT0RFX0RFTlNFEAIqegoSUGVybWlzc2lvbkdyaWRNb2RlEiQKIFBFUk1JU1NJT05fR1JJRF9NT0RFX1VOU1BFQ0lGSUVEEAASHwobUEVSTUlTU0lPTl9HUklEX01PREVfU0lOR0xFEAESHQoZUEVSTUlTU0lPTl9HUklEX01PREVfR1JJRBACKoABChNHdWlsZE1lbWJlclZpZXdNb2RlEiYKIkdVSUxEX01FTUJFUl9WSUVXX01PREVfVU5TUEVDSUZJRUQQABIgChxHVUlMRF9NRU1CRVJfVklFV19NT0RFX1RBQkxFEAESHwobR1VJTERfTUVNQkVSX1ZJRVdfTU9ERV9HUklEEAIqVQoJTWZhTWV0aG9kEhoKFk1GQV9NRVRIT0RfVU5TUEVDSUZJRUQQABITCg9NRkFfTUVUSE9EX1RPVFAQARIXChNNRkFfTUVUSE9EX1dFQkFVVEhOEANiBnByb3RvMw',
		[file_fluxer_user_preferences_v1_accessibility, file_fluxer_user_preferences_v1_pickers],
	);

export type SyncedPreferences = Message<'fluxer.user.preferences.v1.SyncedPreferences'> & {
	accessibility?: AccessibilitySettings | undefined;

	accessibilityOverrides?: AccessibilityOverrides | undefined;

	textualPreview?: TextualPreviewSettings | undefined;

	emojiPicker?: EmojiPickerState | undefined;

	stickerPicker?: StickerPickerState | undefined;

	memesPicker?: MemesPickerState | undefined;

	emoji?: EmojiState | undefined;

	emojiStickerLayout?: EmojiStickerLayoutSettings | undefined;

	favoriteGifs?: FavoriteGifSettings | undefined;

	favorites?: FavoritesState | undefined;

	recentMentions?: RecentMentionsSettings | undefined;

	sidebar?: SidebarPreferences | undefined;

	memberList?: MemberListState | undefined;

	unreadChannels?: UnreadChannelsState | undefined;

	mentionFrecency?: MentionFrecencyState | undefined;

	nagbars?: NagbarDismissals | undefined;

	dismissedUpsells?: DismissedUpsells | undefined;

	guildNsfwAgreements?: GuildNsfwAgreements | undefined;

	whatsNew?: WhatsNewState | undefined;

	privacy?: PrivacyPreferences | undefined;

	localSpamOverrides?: LocalUserSpamOverrides | undefined;

	sanitizeUrls: boolean;

	sound?: SoundSettings | undefined;

	spellcheck?: SpellcheckSettings | undefined;

	searchEngines?: SearchEngineSettings | undefined;

	permissionLayout?: PermissionLayoutSettings | undefined;

	guildMemberLayout?: GuildMemberLayoutSettings | undefined;

	guildFolders?: GuildFolderExpandedState | undefined;

	hiddenGuildButtons?: HiddenGuildListButtons | undefined;

	keyboardModeIntro?: KeyboardModeIntroState | undefined;

	inputMonitoring?: InputMonitoringPromptsState | undefined;

	voicePrompts?: VoicePromptsState | undefined;

	sudoPrompt?: SudoPromptState | undefined;

	keybinds?: KeybindSettings | undefined;
};

export const SyncedPreferencesSchema: GenMessage<SyncedPreferences> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 0);

export type SpellcheckSettings = Message<'fluxer.user.preferences.v1.SpellcheckSettings'> & {
	enabled?: boolean | undefined;

	languages: Array<string>;

	personalDictionary: Array<string>;

	autoDetect?: boolean | undefined;

	engine?: string | undefined;
};

export const SpellcheckSettingsSchema: GenMessage<SpellcheckSettings> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 1);

export type SearchEngineSettings = Message<'fluxer.user.preferences.v1.SearchEngineSettings'> & {
	textSearchEngineId?: string | undefined;

	reverseImageSearchEngineId?: string | undefined;

	translationProviderId?: string | undefined;
};

export const SearchEngineSettingsSchema: GenMessage<SearchEngineSettings> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 2);

export type PrivacyPreferences = Message<'fluxer.user.preferences.v1.PrivacyPreferences'> & {
	disableStreamPreviews: boolean;

	showActiveNow?: boolean | undefined;
};

export const PrivacyPreferencesSchema: GenMessage<PrivacyPreferences> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 3);

export type LocalUserSpamOverrides = Message<'fluxer.user.preferences.v1.LocalUserSpamOverrides'> & {
	spammerUserIds: Array<string>;

	notSpammerUserIds: Array<string>;
};

export const LocalUserSpamOverridesSchema: GenMessage<LocalUserSpamOverrides> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 4);

export type TextualPreviewSettings = Message<'fluxer.user.preferences.v1.TextualPreviewSettings'> & {
	wrapText: boolean;
};

export const TextualPreviewSettingsSchema: GenMessage<TextualPreviewSettings> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 5);

export type SidebarPreferences = Message<'fluxer.user.preferences.v1.SidebarPreferences'> & {
	inlineDmsCollapsed: boolean;

	showCollapsedUnreadDmsBadge?: boolean | undefined;

	showIncomingFriendRequestBadge?: boolean | undefined;
};

export const SidebarPreferencesSchema: GenMessage<SidebarPreferences> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 6);

export type MemberListState = Message<'fluxer.user.preferences.v1.MemberListState'> & {
	membersOpen?: boolean | undefined;
};

export const MemberListStateSchema: GenMessage<MemberListState> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 7);

export type UnreadChannelsState = Message<'fluxer.user.preferences.v1.UnreadChannelsState'> & {
	collapsedChannelIds: Array<string>;
};

export const UnreadChannelsStateSchema: GenMessage<UnreadChannelsState> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 8);

export type RecentMentionsSettings = Message<'fluxer.user.preferences.v1.RecentMentionsSettings'> & {
	includeEveryone?: boolean | undefined;

	includeRoles?: boolean | undefined;

	includeGuilds?: boolean | undefined;
};

export const RecentMentionsSettingsSchema: GenMessage<RecentMentionsSettings> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 9);

export type MentionFrecencyState = Message<'fluxer.user.preferences.v1.MentionFrecencyState'> & {
	scopes: Array<MentionFrecencyState_Scope>;
};

export const MentionFrecencyStateSchema: GenMessage<MentionFrecencyState> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 10);

export type MentionFrecencyState_Entry = Message<'fluxer.user.preferences.v1.MentionFrecencyState.Entry'> & {
	userId: string;

	count: number;

	lastAtMs: bigint;
};

export const MentionFrecencyState_EntrySchema: GenMessage<MentionFrecencyState_Entry> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 10, 0);

export type MentionFrecencyState_Scope = Message<'fluxer.user.preferences.v1.MentionFrecencyState.Scope'> & {
	guildId: string;

	entries: Array<MentionFrecencyState_Entry>;
};

export const MentionFrecencyState_ScopeSchema: GenMessage<MentionFrecencyState_Scope> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 10, 1);

export type FavoritesState = Message<'fluxer.user.preferences.v1.FavoritesState'> & {
	channels: Array<FavoriteChannel>;

	categories: Array<FavoriteCategory>;

	collapsedCategoryIds: Array<string>;

	hideMutedChannels: boolean;

	muted: boolean;
};

export const FavoritesStateSchema: GenMessage<FavoritesState> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 11);

export type FavoriteChannel = Message<'fluxer.user.preferences.v1.FavoriteChannel'> & {
	channelId: string;

	guildId: string;

	parentId?: string | undefined;

	position: number;

	nickname?: string | undefined;
};

export const FavoriteChannelSchema: GenMessage<FavoriteChannel> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 12);

export type FavoriteCategory = Message<'fluxer.user.preferences.v1.FavoriteCategory'> & {
	id: string;

	name: string;

	position: number;
};

export const FavoriteCategorySchema: GenMessage<FavoriteCategory> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 13);

export type NagbarDismissals = Message<'fluxer.user.preferences.v1.NagbarDismissals'> & {
	iosInstall: boolean;

	pwaInstall: boolean;

	pushNotification: boolean;

	desktopNotification: boolean;

	premiumGracePeriod: boolean;

	premiumExpired: boolean;

	premiumOnboarding: boolean;

	premiumTrialExpiring: boolean;

	giftInventory: boolean;

	desktopDownload: boolean;

	guildMembershipCta: boolean;

	visionaryMfa: boolean;

	legacyPhoneUnlink: boolean;

	pendingBulkDeletion: {[key: string]: boolean};

	invitesDisabled: {[key: string]: boolean};
};

export const NagbarDismissalsSchema: GenMessage<NagbarDismissals> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 14);

export type DismissedUpsells = Message<'fluxer.user.preferences.v1.DismissedUpsells'> & {
	pickerPremium: boolean;
};

export const DismissedUpsellsSchema: GenMessage<DismissedUpsells> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 15);

export type GuildNsfwAgreements = Message<'fluxer.user.preferences.v1.GuildNsfwAgreements'> & {
	agreedChannelIds: Array<string>;

	agreedGuildIds: Array<string>;

	agreedCategoryIds: Array<string>;
};

export const GuildNsfwAgreementsSchema: GenMessage<GuildNsfwAgreements> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 16);

export type WhatsNewState = Message<'fluxer.user.preferences.v1.WhatsNewState'> & {
	lastDismissedEntryId?: string | undefined;
};

export const WhatsNewStateSchema: GenMessage<WhatsNewState> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 17);

export type PermissionLayoutSettings = Message<'fluxer.user.preferences.v1.PermissionLayoutSettings'> & {
	layout: PermissionLayoutMode;

	grid: PermissionGridMode;
};

export const PermissionLayoutSettingsSchema: GenMessage<PermissionLayoutSettings> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 18);

export type GuildMemberLayoutSettings = Message<'fluxer.user.preferences.v1.GuildMemberLayoutSettings'> & {
	mode: GuildMemberViewMode;
};

export const GuildMemberLayoutSettingsSchema: GenMessage<GuildMemberLayoutSettings> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 19);

export type GuildFolderExpandedState = Message<'fluxer.user.preferences.v1.GuildFolderExpandedState'> & {
	expandedFolderIds: Array<bigint>;
};

export const GuildFolderExpandedStateSchema: GenMessage<GuildFolderExpandedState> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 20);

export type HiddenGuildListButtons = Message<'fluxer.user.preferences.v1.HiddenGuildListButtons'> & {
	downloadButton: boolean;

	helpButton: boolean;
};

export const HiddenGuildListButtonsSchema: GenMessage<HiddenGuildListButtons> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 21);

export type KeyboardModeIntroState = Message<'fluxer.user.preferences.v1.KeyboardModeIntroState'> & {
	seen: boolean;
};

export const KeyboardModeIntroStateSchema: GenMessage<KeyboardModeIntroState> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 22);

export type InputMonitoringPromptsState = Message<'fluxer.user.preferences.v1.InputMonitoringPromptsState'> & {
	seenCta: boolean;
};

export const InputMonitoringPromptsStateSchema: GenMessage<InputMonitoringPromptsState> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 23);

export type VoicePromptsState = Message<'fluxer.user.preferences.v1.VoicePromptsState'> & {
	skipHideOwnCameraConfirm: boolean;

	skipHideOwnScreenshareConfirm: boolean;
};

export const VoicePromptsStateSchema: GenMessage<VoicePromptsState> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 24);

export type SudoPromptState = Message<'fluxer.user.preferences.v1.SudoPromptState'> & {
	lastUsedMfaMethod?: MfaMethod | undefined;
};

export const SudoPromptStateSchema: GenMessage<SudoPromptState> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 25);

export type KeybindSettings = Message<'fluxer.user.preferences.v1.KeybindSettings'> & {
	customKeybinds: Array<CustomKeybind>;

	transmitMode: string;

	pushToTalkReleaseDelayMs?: number | undefined;
};

export const KeybindSettingsSchema: GenMessage<KeybindSettings> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 26);

export type CustomKeybind = Message<'fluxer.user.preferences.v1.CustomKeybind'> & {
	id: string;

	action?: string | undefined;

	combo?: KeybindCombo | undefined;

	enabled: boolean;
};

export const CustomKeybindSchema: GenMessage<CustomKeybind> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 27);

export type KeybindCombo = Message<'fluxer.user.preferences.v1.KeybindCombo'> & {
	key: string;

	code?: string | undefined;

	ctrlOrMeta: boolean;

	ctrl: boolean;

	alt: boolean;

	shift: boolean;

	meta: boolean;

	global?: boolean | undefined;

	enabled?: boolean | undefined;

	modifierOnly: boolean;

	bothSides: boolean;

	mouseButton?: number | undefined;

	gamepadButton?: number | undefined;
};

export const KeybindComboSchema: GenMessage<KeybindCombo> =
	messageDesc(file_fluxer_user_preferences_v1_preferences, 28);

export enum PermissionLayoutMode {
	UNSPECIFIED = 0,

	COMFY = 1,

	DENSE = 2,
}

export const PermissionLayoutModeSchema: GenEnum<PermissionLayoutMode> =
	enumDesc(file_fluxer_user_preferences_v1_preferences, 0);

export enum PermissionGridMode {
	UNSPECIFIED = 0,

	SINGLE = 1,

	GRID = 2,
}

export const PermissionGridModeSchema: GenEnum<PermissionGridMode> =
	enumDesc(file_fluxer_user_preferences_v1_preferences, 1);

export enum GuildMemberViewMode {
	UNSPECIFIED = 0,

	TABLE = 1,

	GRID = 2,
}

export const GuildMemberViewModeSchema: GenEnum<GuildMemberViewMode> =
	enumDesc(file_fluxer_user_preferences_v1_preferences, 2);

export enum MfaMethod {
	UNSPECIFIED = 0,

	TOTP = 1,

	WEBAUTHN = 3,
}

export const MfaMethodSchema: GenEnum<MfaMethod> =
	enumDesc(file_fluxer_user_preferences_v1_preferences, 3);
